<template>
	<div class="modal-backdrop" @click="close">
		<div class="modal"
			@click.stop=""
			role="dialog"
			aria-describedby="modalDescription"
		>
				<button
					type="button"
					class="btn btn-primary closeButton"
					@click="close"
					aria-label="Close modal"
				>
					x
				</button>
				<div class="modal-header" aria-labelledby="modalTitle">
					<h3 class="modal-title">
						<slot name="modalHeaderContent"></slot>
					</h3>
				</div>
				<div class="modal-content">
					<slot name="modalContent"></slot>
				</div>
				<div class="modal-footer">
					<slot name="modalFooterContent"></slot>
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ModalContent',
		methods: {
			close() {
				this.$emit('close');
			},
		},
	};
</script>

<style lang="scss" scoped>
	.modal-backdrop {
		z-index:500;
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.modal {
		z-index:501;
		background: #FFFFFF;
		min-width:20%;
		min-height:20%;
		max-height:95vh;
		max-width:500px;
		height:auto;
		box-shadow: 2px 2px 20px 1px;
		overflow-x: auto;
		position:relative;
		// padding:10px;
		.modal-header, .modal-content, .modal-footer {
			box-sizing: border-box;
			padding: 10px 20px;
		}


		.modal-header {
			background: $CTred;
			text-align: center;
			padding: 20px;
			.modal-title { 
				color: #FFF;
				z-index:999;
			}
		}
		p:last-child {
			margin-bottom: 0
		}
	}

	.closeButton{
		position:absolute;
		right:0;
		width:50px;
		height:40px;
		//   margin-top:-10px;
		z-index:502;
		//display infront of modal
		background: none;
		border: none;
		border-radius:0;


	}

	.btn-close {
		border: none;
		font-size: 20px;
		padding: 20px;
		cursor: pointer;
		font-weight: bold;
		color: #4AAE9B;
		background: transparent;
	}

	img, iframe{
		max-width:100%;
		max-height:100%;
		height:auto;
		object-fit: contain
	}

	@include media-breakpoint-down(sm) {
		.modal {
			font-size: 0.8em;
		}
	}
</style>